import React from 'react';

const TextareaFormGroup = ({label, isRequired, name, value, onChange, rows = 3}) => {
    return (
        <div className="form-group">
            <label htmlFor={name} className="control-label col-md-4">
                {label}{isRequired ? '*' : ''}
            </label>
            <div className="col-md-8">
                <textarea
                    id={name}
                    name={name}
                    value={value || ''}
                    rows={rows}
                    className="form-control"
                    onChange={(e) => onChange(e.target.value)}></textarea>
            </div>
        </div>
    );
}

export default TextareaFormGroup;